import { render, staticRenderFns } from "./TravelAddressSearchBarComponent.vue?vue&type=template&id=06a16ef2"
import script from "./TravelAddressSearchBarComponent.vue?vue&type=script&lang=js"
export * from "./TravelAddressSearchBarComponent.vue?vue&type=script&lang=js"
import style0 from "./TravelAddressSearchBarComponent.vue?vue&type=style&index=0&id=06a16ef2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports